import { useEffect, useState } from 'react';
import { apiKeysApi } from '../../api/admin.js';

const COMMON_SCOPES = [
  'issue:list', 'issue:read', 'issue:create',
  'deal:list', 'deal:read',
  'webhook_subscription:create',
  '*',
];

export default function ApiKeys() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [info, setInfo] = useState(null);
  const [tokenJustCreated, setTokenJustCreated] = useState(null);

  function refresh() { apiKeysApi.list().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    setInfo(null);
    const fd = new FormData(e.currentTarget);
    const scopes = [...e.currentTarget.querySelectorAll('input[name=scope]:checked')].map((i) => i.value);
    const r = await apiKeysApi.create({ name: fd.get('name'), scopes, expiresAt: fd.get('expiresAt') || null });
    setTokenJustCreated(r.token);
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  async function revoke(id) {
    if (!window.confirm('Revoke this key?')) return;
    await apiKeysApi.revoke(id);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>API Keys</h1>
        <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New API Key'}</button>
      </header>

      {tokenJustCreated && (
        <div className="alert info">
          <strong>Save this token now — it will not be shown again:</strong>
          <pre className="ctx-pre">{tokenJustCreated}</pre>
          <button className="btn ghost small" onClick={() => setTokenJustCreated(null)}>Dismiss</button>
        </div>
      )}
      {info && <div className="alert info">{info}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card">
          <div className="grid-form">
            <label>Name<input name="name" required placeholder="My integration" /></label>
            <label>Expires (optional)<input name="expiresAt" type="datetime-local" /></label>
          </div>
          <h4>Scopes</h4>
          <div className="vendor-grid">
            {COMMON_SCOPES.map((s) => (
              <label key={s} className="vendor-pick">
                <input type="checkbox" name="scope" value={s} /> <span><code>{s}</code></span>
              </label>
            ))}
          </div>
          <p className="muted small">Scopes use the format <code>resource:action</code> or <code>resource:*</code>. <code>*</code> grants everything.</p>
          <div className="actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Prefix</th><th>Scopes</th><th>Last used</th><th>Expires</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((k) => {
              const scopes = typeof k.scopes === 'string' ? JSON.parse(k.scopes) : k.scopes;
              const status = k.revoked_at ? 'revoked' : (k.expires_at && new Date(k.expires_at) < new Date()) ? 'expired' : 'active';
              return (
                <tr key={k.id}>
                  <td><strong>{k.name}</strong></td>
                  <td><code>{k.prefix}</code></td>
                  <td className="muted small">{scopes?.join(', ')}</td>
                  <td className="muted small">{k.last_used_at ? new Date(k.last_used_at).toLocaleString() : 'never'}</td>
                  <td className="muted small">{k.expires_at ? new Date(k.expires_at).toLocaleString() : 'never'}</td>
                  <td><span className={`chip status-${status === 'active' ? 'active' : 'cancelled'}`}>{status}</span></td>
                  <td>{!k.revoked_at && <button className="btn ghost small" onClick={() => revoke(k.id)}>Revoke</button>}</td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={7} className="muted">No API keys yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
